import React from 'react';
import { RefreshCw } from 'lucide-react';
import Button from './Button';

/**
 * Standard refresh control used across all data pages.
 * - Desktop (sm+): refresh icon + "Refresh" label.
 * - Mobile: icon only (label hidden), tooltip still shows "Refresh".
 * - Spins the icon and shows "Refreshing…" while `loading` is true.
 *
 * Props: onClick, loading (bool), label (default "Refresh"), plus any
 * Button props (variant, size, className, etc.).
 */
const RefreshButton = ({
  onClick,
  loading = false,
  label = 'Refresh',
  variant = 'outline',
  size = 'sm',
  className = '',
  ...props
}) => (
  <Button
    type="button"
    variant={variant}
    size={size}
    onClick={onClick}
    disabled={loading}
    title={label}
    aria-label={label}
    className={className}
    {...props}
  >
    <RefreshCw className={`h-4 w-4 ${loading ? 'animate-spin' : ''}`} />
    <span className="hidden sm:inline sm:ml-2">{loading ? 'Refreshing…' : label}</span>
  </Button>
);

export default RefreshButton;
